import { render, staticRenderFns } from "./LgFinderPageTipoBaixa.vue?vue&type=template&id=2bb4d031&scoped=true"
import script from "./LgFinderPageTipoBaixa.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoBaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4d031",
  null
  
)

export default component.exports